import { ReactComponent as UpdownIcon } from "./Icons/up-down-arrow.svg";

function TableHead({ commonKeys, headerKeys, setSort, setOrder, order }) {
  return (
    <thead>
      <tr>
        {headerKeys.map((head) => {
          if (head.sortable) {
            return (
              commonKeys[`${head.name}`] && (
                <th
                  key={head.name}
                  onClick={() => {
                    setOrder(order === "asc" ? "desc" : "asc");
                    setSort(head.name);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <span>{head.lable}</span>
                    <UpdownIcon style={{ width: "20px", marginLeft: "5px" }} />
                  </div>
                </th>
              )
            );
          }
          return commonKeys.ticker && <th key={head.name}>{head.lable}</th>;
        })}
      </tr>
    </thead>
  );
}

export default TableHead;
